var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"files-dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.upload_success,"vdropzone-error":_vm.upload_error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }